import { Injectable, inject } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { Fraction } from './fraction';
import { Odds } from './odds';

@Injectable()
export class OddsComparerFactory {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    createComparer(odds: Odds): OddsComparer {
        return new OddsComparer(odds, this.userOddsFormatSettingsService.oddsFormat);
    }

    createDefaultFormatComparer(odds: Odds): OddsComparer {
        return new OddsComparer(odds);
    }
}

export class OddsComparer {
    constructor(
        private odds: Odds,
        private oddsFormat: OddsDisplayFormat = OddsDisplayFormat.EU,
    ) {}

    equal(other: Odds) {
        return this.compareTo(other) === 0;
    }

    lessThan(other: Odds): boolean {
        return this.compareTo(other) === -1;
    }

    greaterThan(other: Odds): boolean {
        return this.compareTo(other) === 1;
    }

    lessOrEqualThan(other: Odds): boolean {
        return this.compareTo(other) <= 0;
    }

    greaterOrEqualThan(other: Odds): boolean {
        return this.compareTo(other) >= 0;
    }

    private compareTo(otherOdds: Odds): number {
        switch (this.oddsFormat) {
            case OddsDisplayFormat.EU:
                return this.odds.decimals < otherOdds.decimals ? -1 : this.odds.decimals > otherOdds.decimals ? 1 : 0;
            case OddsDisplayFormat.UK:
                return Fraction.fromJSON(this.odds.fractional).compare(Fraction.fromJSON(otherOdds.fractional));
            case OddsDisplayFormat.US:
                return this.odds.moneyline < otherOdds.moneyline ? -1 : this.odds.moneyline > otherOdds.moneyline ? 1 : 0;
        }
    }
}
